export type HapticFeedbackEvent =
  | "challenge-complete"
  | "food-pickup"
  | "personal-best"
  | "player-defeat"
  | "snake-eaten"
  | "turbo";

export type HapticFeedbackSignal =
  "impact-heavy" | "impact-light" | "impact-medium" | "notification-success";

const signalByEvent: Readonly<
  Record<HapticFeedbackEvent, HapticFeedbackSignal>
> = {
  "challenge-complete": "impact-heavy",
  "food-pickup": "impact-light",
  "personal-best": "notification-success",
  "player-defeat": "impact-medium",
  "snake-eaten": "impact-light",
  turbo: "impact-light",
};

export const hapticFeedbackConfig: {
  readonly cooldownMs: Readonly<Record<HapticFeedbackEvent, number>>;
} = {
  cooldownMs: {
    "challenge-complete": 1_500,
    "food-pickup": 120,
    "personal-best": 1_500,
    "player-defeat": 1_200,
    "snake-eaten": 250,
    turbo: 350,
  },
};

export const hapticSignalFor = (
  event: HapticFeedbackEvent,
): HapticFeedbackSignal => signalByEvent[event];
